export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const EMAIL = 'a.zelcs@andersenlab.com';

export const MEETUP_DATE = '2025-10-07';
export const MEETUP_TIME = '17:30 (GMT+1)';
